// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vhTsK","col":"styles_col__1Ir10","actions":"styles_actions__17kim","conflict":"styles_conflict__2RPMt"};